interface MatchTeamsScoreProps {
	teamOneTitle: string;
	teamTwoTitle: string;
	teamOneTotal: number;
	teamTwoTotal: number;
	isMatchOverAndCompleted: boolean;
}

export const MatchTeamsScore = ({ teamOneTitle, teamTwoTitle, teamOneTotal, teamTwoTotal, isMatchOverAndCompleted }: MatchTeamsScoreProps) => {
	return (
		<>
			{/* Mobile view */}
			<div className="sm:hidden flex flex-col gap-2 sticky top-0 z-10 bg-white pt-4 pb-4 border-b border-b-darkorange-400">
				<div className="flex justify-between items-center text-sm">
					<p className="text-base font-medium text-blue-500">
						{teamTwoTitle} <span className="text-black">(A)</span>
					</p>
					<p
						className={`text-base font-semibold px-2 py-1 rounded
      ${isMatchOverAndCompleted && teamTwoTotal > teamOneTotal ? 'bg-green-600 text-white' : 'bg-orange-100'}`}
					>
						{teamTwoTotal}
					</p>
				</div>

				<div className="flex justify-between items-center text-sm">
					<p className="text-base font-medium text-blue-500">
						{teamOneTitle} <span className="text-black">(H)</span>
					</p>
					<p
						className={`text-base font-semibold px-2 py-1 rounded
      ${isMatchOverAndCompleted && teamOneTotal > teamTwoTotal ? 'bg-green-600 text-white' : 'bg-orange-100'}`}
					>
						{teamOneTotal}
					</p>
				</div>
			</div>

			{/* Desktop/tablet view */}
			<div className="hidden sm:grid grid-rows-3 sticky top-0 z-10 bg-white sm:grid-rows-1 justify-center sm:grid-cols-[200px_auto_200px] sm:justify-between items-center gap-4 text-center pt-4 pb-4 border-b border-b-darkorange-400">
				{/* Team A */}
				<p className="text-2xl font-medium text-blue-500">
					{teamTwoTitle} <span className="text-black">(A)</span>
				</p>

				<div className="flex flex-col gap-2 items-center">
					<div className="flex gap-2 items-center">
						<div
							className={`flex justify-center border-spacing-2 rounded-lg size-11 py-[6px] px-[14px] 
								${isMatchOverAndCompleted && teamTwoTotal > teamOneTotal ? 'bg-green-600 text-white' : 'bg-orange-100'}`}
						>
							<p className="font-medium text-2xl">{teamTwoTotal}</p>
						</div>
						<span className="items-center">-</span>
						<div
							className={`flex justify-center border-spacing-2 rounded-lg size-11 py-[6px] px-[14px] 
								${isMatchOverAndCompleted && teamOneTotal > teamTwoTotal ? 'bg-green-600 text-white' : 'bg-orange-100'}`}
						>
							<p className="font-medium text-2xl">{teamOneTotal}</p>
						</div>
					</div>
				</div>

				<p className="text-2xl font-medium text-blue-500">
					{teamOneTitle} <span className="text-black">(H)</span>
				</p>
			</div>
		</>
	);
};
